exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* footrt */\nfooter {\n  margin-left: 0;\n  background: #1588ca;\n}\n.app-footer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 0 1rem;\n  color: white;\n  background: #1588ca;\n  border-top: 0px solid #c2cfd6;\n}\n.aside-menu-fixed.aside-menu-hidden .main,\n.aside-menu-fixed.aside-menu-hidden .app-footer {\n  margin-right: 0;\n  margin-left: 0;\n  padding: 10px;\n}\n.footer_txt {\n  float: left;\n}\n.footer_txt p {\n  margin-bottom: 0;\n  font-weight: 700;\n  font-size: 15px;\n}\n/* footer */\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/src/app/components/app-footer-public/app-footer-public.component.css
// module id = ../../../../../src/app/components/app-footer-public/app-footer-public.component.css
// module chunks = main